<template>
  <vs-popup class="popup-reformation-result" :title="title" :active.sync="showPopup">
    <div>
      <div class="mb-4" vs-type="flex">
        <h5><i class="dot"></i> 개선결과</h5>
      </div>
      <div class="writeGridContainer">
        <div class="col-span-6">
          <label>개선 완료일</label>
          <date-selector v-model="form.개선결과.개선완료일" />
        </div>
        <div class="writeGridLineItem">
          <label>개선 내역</label>
          <ml-textarea type="text" v-model="form.개선결과.개선내역" />
        </div>
      </div>
      <!--파일첨부-->
      <file-upload-module class="mt-28px" v-model="form.개선결과.fileList" />

      <div class="flex justify-end gap-4">
        <vs-button type="border" color="secondary" @click="close">닫기</vs-button>
        <vs-button color="secondary" @click="save">저장</vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import DateSelector from "@/components/selector/DateSelector.vue";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";

export default {
  components: {FileUploadModule, DateSelector},
  props: {
    title: {
      type: String,
      default: "개선결과",
    },
    value: Boolean,
    dataCode: String,
    postId: Number,
    data: Object,
    readonly: Boolean,
  },
  computed: {
    showPopup: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (value) {

          if (this.data) {
            const keys = Object.keys(this.data);
            for (const key of keys) {
              if (this.data[key]) {
                this.form[key] = this.data[key];
              }
            }
          } else {
            // 초기화
            this.form = {
              dataCode: this.dataCode,
              개선결과: {
                개선완료일: '',
                개선내역: '',
                fileList: [],
              }
            }
          }
        }
      }
    }
  },
  data () {
    return {
      form: {
        dataCode: this.dataCode,
        개선결과: {
          개선완료일: '',
          개선내역: '',
          fileList: [],
        }
      }
    }
  },
  methods: {
    close() {
      this.showPopup = false;
    },
    save() {
      this.form.dataCode = this.dataCode;
      this.$emit("save", this.postId, this.form)
      this.showPopup = false;
    }
  }
}
</script>

<style scoped lang="scss">
.popup-reformation-result::v-deep {
  .vs-popup {
    width: 840px;
  }
}
</style>
